<template>
  <div>
    {{ getUser(orderData) }}
    <div
      class="hover-content"
      style="width: 350px !important; left: 130px !important"
    >
      <div class="popover-arrow-left">&nbsp;</div>
      <div
        v-if="orderData.ordered_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Ordered By</div>
        <div class="text-right">{{ orderData.ordered_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.ordered_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.shiponlied_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.shiponlied_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Ship Only By</div>
        <div class="text-right">{{ orderData.shiponlied_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.shiponlied_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.pending_answer_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.pending_answer_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Pending Answered By</div>
        <div class="text-right">{{ orderData.pending_answer_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.pending_answer_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.processed_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.processed_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Processed By</div>
        <div class="text-right">{{ orderData.processed_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.processed_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.canceled_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.canceled_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Canceled By</div>
        <div class="text-right">{{ orderData.canceled_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.canceled_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.approved_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.approved_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Approved By</div>
        <div class="text-right">{{ orderData.approved_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.approved_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.refunded_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.refunded_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Refunded By</div>
        <div class="text-right">{{ orderData.refunded_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.refunded_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.purchased_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.purchased_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Purchased By</div>
        <div class="text-right">{{ orderData.purchased_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.purchased_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.warehouse_delivered_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.warehouse_delivered_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Warehoused By</div>
        <div class="text-right">{{ orderData.warehouse_delivered_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.warehouse_delivered_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.shipmented_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.shipmented_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Shipped By</div>
        <div class="text-right">{{ orderData.shipmented_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.shipmented_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.pending_to_branch_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.pending_to_branch_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">
          <div>Pending To Branch By</div>
          <!-- <div>Branch By</div> -->
        </div>
        <div class="text-right">{{ orderData.pending_to_branch_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.pending_to_branch_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.branch_delivered_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.branch_delivered_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Brand Delivered By</div>
        <div class="text-right">{{ orderData.branch_delivered_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.branch_delivered_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.delivered_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.delivered_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Delivered By</div>
        <div class="text-right">{{ orderData.delivered_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.delivered_by.user_id }}</span> </div>
      </div>

      <div
        v-if="orderData.archived_by"
        style="border-bottom: 1px dashed #ddd;"
      />

      <div
        v-if="orderData.archived_by"
        class="d-flex my-2"
      >
        <div style="width: 40%">Archived By</div>
        <div class="text-right">{{ orderData.archived_by.full_name }} <span
            class="pl-1"
            style="opacity: 0.7; font-size: 12px"
          >#{{ orderData.archived_by.user_id }}</span> </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: ['orderData'],

  methods: {
    getUser(order) {
      if (order.status_id_fk === 1) return order.ordered_by.full_name

      if (order.status_id_fk === 12) return order.shiponlied_by.full_name

      if (order.status_id_fk === 14) return order.pending_answer_by.full_name

      if (order.status_id_fk === 2) return order.processed_by.full_name

      if (order.status_id_fk === 3 || order.is_canceled === '1') return order.canceled_by.full_name

      if (order.status_id_fk === 4) return order.approved_by.full_name

      if (order.status_id_fk === 5) return order.refunded_by.full_name

      if (order.status_id_fk === 6) return order.purchased_by.full_name

      if (order.status_id_fk === 7) return order.warehouse_delivered_by.full_name

      if (order.status_id_fk === 8) return order.shipmented_by.full_name

      if (order.status_id_fk === 13) return order.pending_to_branch_by.full_name

      if (order.status_id_fk === 9) return order.branch_delivered_by.full_name

      if (order.status_id_fk === 10) return order.delivered_by.full_name

      if (order.status_id_fk === 11) return order.archived_by.full_name
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/viewOrderUsers.vue